import React, { useEffect, useState } from "react";
import { ViewForms } from "./view-forms";
import { ModifyForm } from "./modify-form";
import { GetDynamicFormsForAdminPage } from "../../../../../../services/api/task-form-api";
import { PulseLoader } from "react-spinners";
import "./form-design.scss";
import {
  AddFormUtil,
  DeleteFormUtil,
  RemoveEmptyIds,
  RenameFormUtil,
} from "./form-design-util";
import PropTypes from "prop-types";

export const FormDesign = ({
  taskTypeId,
  SetDynamicForms,
  formDataFromParent,
}) => {
  const taskTypeIdToInt = parseInt(taskTypeId);
  const [formView, setFormView] = useState({
    isAllForm: true,
    displayOrderForm: "",
  });
  const [allForms, setAllForms] = useState({
    data: [],
    DynamicFormIdsToBeDeleted: [],
    DynamicSubFormIdsToBeDeleted: [],
    DynamicFormFieldIdsToBeDeleted: [],
    isLoading: true,
  });

  useEffect(() => {
    const LoadForms = async () => {
      try {
        if (!formDataFromParent) {
          let result = [];
          if (taskTypeIdToInt > 0) {
            result = await GetDynamicFormsForAdminPage(taskTypeIdToInt);
          }
          setAllForms((prev) => ({
            ...prev,
            data: result.data,
            isLoading: false,
          }));
        } else {
          setAllForms((prev) => ({
            ...prev,
            data: formDataFromParent.data,
            DynamicFormIdsToBeDeleted:
              formDataFromParent.DynamicFormIdsToBeDeleted,
            DynamicSubFormIdsToBeDeleted:
              formDataFromParent.DynamicSubFormIdsToBeDeleted,
            DynamicFormFieldIdsToBeDeleted:
              formDataFromParent.DynamicFormFieldIdsToBeDeleted,
            isLoading: false,
          }));
        }
      } catch (e) {
        console.log("Error [GetDynamicFormForAdminPage] => ", e);
      }
    };
    LoadForms();
  }, []);

  useEffect(() => {
    SetDynamicForms(allForms);
  }, [allForms]);

  const RenameForm = (label, formDisplayOrder) => {
    const trimmed = label.trim();
    if (!trimmed) return;

    const isDuplicate = allForms.data.some(
      (f) => f.DisplayOrder !== formDisplayOrder && f.Label === trimmed
    );
    if (isDuplicate) return;

    const newForms = RenameFormUtil(allForms.data, formDisplayOrder, trimmed);

    setAllForms((prev) => ({
      ...prev,
      data: newForms,
    }));
  };

  const DeleteForm = (formDisplayOrder) => {
    const { newForms, newFormId } = DeleteFormUtil(
      allForms.data,
      formDisplayOrder
    );

    setAllForms((prev) => ({
      ...prev,
      DynamicFormIdsToBeDeleted: RemoveEmptyIds(
        prev.DynamicFormIdsToBeDeleted,
        newFormId
      ),
      data: newForms,
    }));
  };

  const AddForm = () => {
    const { newForms, newFormDisplayOrder } = AddFormUtil(allForms.data);

    setAllForms((prev) => ({
      ...prev,
      data: newForms,
    }));
    setFormView((prev) => ({
      ...prev,
      isAllForm: false,
      displayOrderForm: newFormDisplayOrder,
    }));
  };

  return (
    <div className="form-design">
      {!formView.isAllForm ? (
        <ModifyForm
          allForms={allForms}
          currentForm={allForms.data.find(
            (f) => f.DisplayOrder === formView.displayOrderForm
          )}
          RenameForm={RenameForm}
          setAllForms={setAllForms}
          setFormView={setFormView}
        ></ModifyForm>
      ) : allForms.isLoading ? (
        <div className="pulse-loader" data-testid="loading-spinner">
          <PulseLoader></PulseLoader>
        </div>
      ) : (
        <ViewForms
          setFormView={setFormView}
          allForms={allForms}
          RenameForm={RenameForm}
          DeleteForm={DeleteForm}
          AddForm={AddForm}
        ></ViewForms>
      )}
    </div>
  );
};

FormDesign.propTypes = {
  taskTypeId: PropTypes.string,
  SetDynamicForms: PropTypes.func,
  formDataFromParent: PropTypes.shape({
    data: PropTypes.array,
    DynamicFormIdsToBeDeleted: PropTypes.array,
    DynamicSubFormIdsToBeDeleted: PropTypes.array,
    DynamicFormFieldIdsToBeDeleted: PropTypes.array,
  }),
};
